export default __webpack_public_path__ + "static/media/buying-options.72dec619.png";